import React, { useMemo } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const ProtectedRoute = ({ children }) => {
    const { user, loading } = useAuth();
    const location = useLocation();

    const routeContent = useMemo(() => {
        if (loading) {
            return <div>Loading...</div>; // Show a loading indicator while checking auth
        }

        if (!user) {
            return <Navigate to="/login" state={{ from: location }} replace />;
        }

        return children; // Render protected children if user exists
    }, [loading, user, children, location]);

    return routeContent;
};

export default ProtectedRoute;


// // src/components/ProtectedRoute/ProtectedRoute.js
// import React from 'react';
// import { Navigate, useLocation } from 'react-router-dom';
// import { useAuth } from '../../context/AuthContext';
//
// const ProtectedRoute = ({ children }) => {
//     const { user, loading } = useAuth();
//     const location = useLocation();
//
//     if (loading) {
//         return <div>Loading...</div>; // Or your loading component
//     }
//
//     if (!user) {
//         return <Navigate to="/login" state={{ from: location }} replace />;
//     }
//
//     return children;
// };
//
// export default ProtectedRoute;